import axios from 'axios';
import {
  DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_BEGIN,
  DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_SUCCESS,
  DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_FAILURE,
  DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCodeExportRequestList(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/code-export`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCodeExportRequestListError() {
  return {
    type: DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_BEGIN:
      return {
        ...state,
        loadCodeExportRequestListPending: true,
        loadCodeExportRequestListError: null,
      };

    case DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loadCodeExportRequestListPending: false,
        loadCodeExportRequestListError: null,
        exportRequestList: action.data,
      };

    case DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_FAILURE:
      return {
        ...state,
        loadCodeExportRequestListPending: false,
        loadCodeExportRequestListError: action.data.error,
      };

    case DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_DISMISS_ERROR:
      return {
        ...state,
        loadCodeExportRequestListError: null,
      };

    default:
      return state;
  }
}
